import { Table, ApiClientConstant } from '@cureskin/api-client';
import { Component, Input, Output, EventEmitter, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OrderService } from '@services/order-service/order.service';
import { CsIconModule } from '@components/icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'order-delivered',
  imports: [CsIconModule, CommonModule, RouterModule],
  templateUrl: './order-delivered.component.html',
})
export class OrderDeliveredComponent implements OnInit {
  public readonly orderService: OrderService = inject(OrderService);
  public readonly ApiClientConstant = ApiClientConstant;

  @Input() isRebrandingBanner: boolean;
  @Input() isPartialCancellationUIEnabled: boolean = false;
  @Input() order: Table.Order;
  @Output() addEvents: EventEmitter<any> = new EventEmitter();

  orderedProductsCount: number;
  cancelledProducts: Array<Table.Order['attributes']['productApprovalDetails']['productDetails'][number]> = [];
  shouldShowPartialOrderCancellationUI: boolean;
  cancelledProductsCount: number = 0;
  totalProductsCount: number = 0;

  constructor() {}

  get orderUrl(): string {
    return `/user/order/${this.order?.id}`;
  }

  ngOnInit(): void {
    const approvalData = this.orderService.initializeProductApprovalData(this.order, this.isPartialCancellationUIEnabled);
    this.cancelledProducts = approvalData.cancelledProducts;
    this.orderedProductsCount = approvalData.orderedProductsCount;
    this.shouldShowPartialOrderCancellationUI = approvalData.shouldShowPartialOrderCancellationUI;
    this.cancelledProductsCount = approvalData.cancelledProductsCount;
    this.totalProductsCount = approvalData.totalProductsCount;
  }

  handleClick(): void {
    this.addEvents.emit();
  } 
}
